import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { Typography } from 'shared/ui'
import { useBuyNumberStepsContext } from 'pages/settings/pages/numbers/pages/BuyNumber/context/useBuyNumberStepsContext'
import { PaymentCommon } from 'pages/settings/ui/PaymentCommon/PaymentCommon'
import styles from './styles.module.scss'

export const Payment = observer(() => {
  const { paymentStore, chooseNumberStore, confirmNumber, numbersLayerStore } =
    useBuyNumberStepsContext()

  const { isUKSelected, state } = chooseNumberStore.chooseNumberTabsStore

  useEffect(() => {
    return () => {
      paymentStore.dropdownCardsStore.setFirstActive()
    }
  }, [])

  const numberDescription = () => {
    if (isUKSelected) {
      return 'Mobile number'
    }

    if (state?.state_name) {
      return (
        <Typography ariaLabel='stateName' className={styles.stateName}>
          Local number <div className={styles.dot} /> {state.state_name}
        </Typography>
      )
    }

    return null
  }

  return (
    <PaymentCommon
      numberDescription={numberDescription()}
      paymentStore={paymentStore}
      formattedNumber={chooseNumberStore.chooseNumberTabsStore.selectedNumber?.formatted || ''}
      stepLoading={numbersLayerStore.stepsStore.stepLoading}
      confirmNumber={confirmNumber}
    />
  )
})
